import { Factor, maxWeightsSum, Option, weightToBucket, sumFactorWeights } from './choices';
import { RockContainer, VizContainerProps, VizInner } from './Rocks';


export const behavioralOptions: Option[] = [
    {
        id: 'shower',
        label: 'Shower Length',
        options: [
            { value: 'navy_shower', label: 'No Shower', weight: 0 },
            { value: 'two_min', label: '2 Minutes', weight: 1 },
            { value: 'five_min', label: '5 Minutes', weight: 1 },
            { value: 'ten_min', label: '10 Minutes', weight: 2 },
            { value: 'fifteen_min', label: '15 Minutes', weight: 3 },
        ]
    },
    {
        id: 'transportation',
        label: 'Transportation',
        options: [
            { value: 'walk_bike', label: 'Walk/Bike Only', weight: 0 },
            { value: 'public_transit', label: 'Public Transit', weight: 1 },
            { value: 'standard_car', label: 'Drive', weight: 2 },
            { value: 'frequent_flyer', label: 'Frequent Flyer (1+ Flight/Year)', weight: 3 },
        ]
    },
    {
        id: 'energy',
        label: 'Home Energy Usage',
        options: [
            { value: 'minimal_energy', label: 'No Lights', weight: 0 },
            { value: 'one_light', label: 'Max 1 Light Per Room', weight: 1 },
            { value: 'appliances', label: 'Regular Dishwasher/Dryer Use', weight: 2 },
            { value: 'excessive_energy', label: 'Multiple High-Energy Appliances', weight: 3 },
        ]
    },
];

const behavioralMessages: { [key: number]: string } = {
    1: "Your choices place a pebble on others. Your lifestyle has minimal impact on other people and communities.",
    2: "Your choices place a stone on others. Your lifestyle has a small but noticeable impact on people and communities worldwide.",
    3: "Your choices place a boulder on others. Your consumption patterns create significant burdens for other people and communities.",
    4: "Your choices place a mountain on others. Your daily decisions contribute to major systemic burdens that significantly impact vulnerable populations."
};

const defaultBehaviorMessage = "Your choices create minimal impact on others. Your lifestyle decisions aim to minimize harm to other people and communities.";

export const maxBehavioralWeightsSum = maxWeightsSum(behavioralOptions);

export const getBehaviorMessage = (bucketIdx: number): string => {
    return behavioralMessages[bucketIdx] || "The weight of your choices affects the lives of others.";
}

export const BehaviorViz: React.FC<VizContainerProps> = ({ color, gradientEnd, factors, maxFactorWeightsSum, defaultMessage, getMessage }) => {
    return (
        <VizInner
            color={color}
            gradientEnd={gradientEnd}
            factors={factors}
            maxFactorWeightsSum={maxFactorWeightsSum}
            defaultLabel="None"
            defaultMessage={defaultMessage}
            getMessage={getMessage}
            twoFigs={true}
        />
    );
}

export const renderBehaviorViz = ({ factors }: { factors: Factor[] }) => {
    const rockIndex = weightToBucket(sumFactorWeights(factors), maxBehavioralWeightsSum);
    const rockColor = `hsl(15, 60%, ${100 - (rockIndex * 10)}%)`;

    return <BehaviorViz
        color={rockColor}
        factors={factors}
        maxFactorWeightsSum={maxBehavioralWeightsSum}
        defaultLabel="None"
        defaultMessage={defaultBehaviorMessage}
        getMessage={getBehaviorMessage}
    />
};

export const renderBehaviorRock = ({ factors }: { factors: Factor[] }) => {
    const idx = weightToBucket(sumFactorWeights(factors), maxBehavioralWeightsSum);
    const color = `hsl(30, 35%, ${100 - (idx * 10)}%)`;

    return <RockContainer rockIndex={sumFactorWeights(factors) === 0 ? 0 : idx} color={color} defaultLabel="None" />
}